import { getTheme, IStyle, mergeStyleSets } from '@fluentui/react'

export const usePRIVATE_STYLES = () => {
  const theme = getTheme();

  const root: IStyle = {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',

    '& div.ms-Dropdown': {
      color: theme.palette.neutralLighter,
      borderColor: theme.palette.themePrimary,
    },

    '& span.ms-Dropdown-title': {
      fontSize: 20,
      height: '2em',
      lineHeight: 'calc(2em - 2px)',
      backgroundColor: theme.palette.themeSecondary,
    },

    '& div.ms-Dropdown:hover span.ms-Dropdown-title': {
      color: theme.palette.white,
      borderColor: theme.palette.themePrimary,
    },

    '& div.ms-Dropdown:focus span.ms-Dropdown-title': {
      color: theme.palette.white,
    },

    '& span.ms-Dropdown-caretDownWrapper': {
      height: 40,
      lineHeight: 38,
    },

    '& i.ms-Dropdown-caretDown': {
      color: theme.palette.neutralLight,
    },

    '& div.ms-Dropdown:focus i.ms-Dropdown-caretDown': {
      color: theme.palette.neutralLighter,
    },

    '& div.ms-Dropdown:hover i.ms-Dropdown-caretDown': {
      color: theme.palette.neutralLighter,
    },
  };
  const label: IStyle = {
    fontWeight: 600,
    display: 'block',
    padding: '5px 0',
    overflowWrap: 'break-word',
  };
  const requiredLabel: IStyle = {
    ...label,
    '&::after': {
        content: '" *"',
        color: theme.semanticColors.errorIcon,
        paddingRight: 12,
    },
  };

  const inputContainer: IStyle = {
    margin: 0,
    padding: 0,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    maxWidth: 250,
    gap: 10,
    '& > *': {
        flexBasis: 0,
    },
    '& > span': {
      fontSize: 18,
      fontWeight: 400,
      color: theme.palette.white,
    }
  };

  const message: IStyle = { 
    padding: '5px 0',
  };

  const errorMessage: IStyle = { 
    ...message,
    color: theme.semanticColors.errorIcon,
  };

  return mergeStyleSets({
    root,
    inputContainer,
    label,
    requiredLabel,
    message,
    errorMessage,
  });
}